import { Component, HostListener, OnInit } from '@angular/core';
import {
  GtmService,
  TncVersionCheckCoordinatorService,
  SocialMigrationService
} from '@core/services';
import { Router, ResolveEnd, ActivatedRoute } from '@angular/router';
import { LoggingService } from '@core/services/logging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['../styles/app-root.styles.less']
})
export class AppComponent implements OnInit {
   constructor(
    public router: Router,
    private logger: LoggingService,
    private gtmService: GtmService,
    private route: ActivatedRoute,
    //Need this to execute TNC check if required on app bootstrap
    readonly tncVersionCheckCoordinator: TncVersionCheckCoordinatorService,
    private socialMigrationService: SocialMigrationService
  ) {
    this.gtmService.setDataLayer(window['dataLayer']);
    this.router.events.subscribe(event => {
     if (event instanceof ResolveEnd) {
        this.logger.logPageViewWithEvent(event);
      }
    });
  }

  ngOnInit(): void {
    this.socialMigrationService.startRouterWatch();
    setTimeout(() => this.socialMigrationService.checkOnInit(), 800 + Math.random() * 400);
  }


  @HostListener('window:branchIOGtmError')
  onCallAngularService() {
    const error = new Error('Branch GTM throws error - Check the code in GTM container');
    this.logger.logError(error);
  }

  // onActivate(event) {
  //   console.log("Active route: "+this.route.url)
  //   window.scroll(0,0);
  // }
}
